export default __webpack_public_path__ + "static/media/Junaid-CV.2d52b42e.pdf";